import React from 'react';
import {iconWarning} from "./Icon";
import {ajaxStatusCore, WEBSERVICE_AJAX_ID} from "../app/Webservice";
import {AjaxSpinner} from 'dts-react-common';

const propTypes = {};

const defaultProps = {};

class NoOfferFound extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isAjaxing: true,
		};

		this.getOfferAjaxing = ajaxStatusCore.registerChangedCallback((ajaxId, isAjaxing) => {
			this.setState({isAjaxing: isAjaxing});
		}, WEBSERVICE_AJAX_ID.GET_OFFER);
	}

	componentWillUnmount() {
		ajaxStatusCore.unregisterChangedCallback(this.getOfferAjaxing);
	}

	render() {
		return (
			<div className="page-error flex direction-col center align-center">
				{this.state.isAjaxing
					? <AjaxSpinner size={100} labelName="Loading..."/>
					: <React.Fragment>
						<div>{iconWarning()}</div>
						<h2>The offer you are trying to access cannot be found.</h2>
						<p>Please contact your hiring manager for further assistance.</p>
					</React.Fragment>
				}
			</div>
		);
	}

}

NoOfferFound.propTypes = propTypes;
NoOfferFound.defaultProps = defaultProps;

export default NoOfferFound;